import { LAYOUT_PAGE__open_app_if_authorized } from '@/page_wrappers/LAYOUT_PAGE__open_app_if_authorized';
import { ROUTE__base } from './ROUTE__base';

export function ROUTE__auth(path: string, element: React.ReactNode) {
  return ROUTE__base(path, <LAYOUT_PAGE__open_app_if_authorized page={element} />);
}
